<template>
  <figure :class="orientation" :style="wrapperStyles">
    <ResponsiveImage
      :image="image"
      :ratio="ratio"
      :data-media-scroll-anchor="image._key"
      @aspect="setAspect"
      @orientation="setOrientation"
    />
    <figcaption>
      <span>
        <slot v-bind:image="image">{{ image.caption }}</slot>
      </span>
      <span>{{ image.attribution }}</span>
    </figcaption>
  </figure>
</template>

<script>
import ResponsiveImage from '@/components/ResponsiveImage'

export default {
  name: 'Media',
  props: {
    image: {
      type: Object,
      required: true
    },
    ratio: {
      type: Boolean,
      default: true
    }
  },
  components: { ResponsiveImage },
  data() {
    return {
      aspect: 0,
      orientation: ''
    }
  },
  computed: {
    wrapperStyles() {
      return { '--aspect-ratio': this.aspect }
    }
  },
  methods: {
    setAspect(aspect) {
      this.aspect = aspect
    },
    setOrientation(orientation) {
      this.orientation = orientation
    }
  }
}
</script>

<style scoped>
figcaption {
  @mixin type-medium--serif-cond;
  padding-top: 0.5em;
  > span {
    display: block;
  }
  > span + span {
    font-size: 0.75em;
  }
}
</style>
